import { render, staticRenderFns } from "./ProductReturn.vue?vue&type=template&id=77e61855&"
import script from "./ProductReturn.vue?vue&type=script&lang=js&"
export * from "./ProductReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports